import { FormLabel as BaseFormLabel } from "ui/components/form";
import { Label } from "ui/components/label";

export function FormColumns(props) {
  return <div className="grid grid-cols-2 gap-4" {...props} />;
}

export const FormLabel = ({ children, required, className }) => (
  <Label className={className}>
    <div>
      {children}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </div>
  </Label>
);

export { FormTextarea } from "./textarea";
export { FormInput } from "./input";
export { FormDatePicker } from "./date-picker";
export { TiptapEditor } from "./tiptap-editor";
export { FormSwitch } from "./switch";
export { FormSelectName } from "./select-name";
export { FormSelectStatus } from "./select-status";
export { FormSurveyCategoryQuestions } from "./survey-category-questions";
